export enum FeedbackFilterType {
  All = 'all',
  Members = 'user',
  Auto = 'system',
}
